<template>
  <div class="assessment-layout">
    <Sidebar />
    <main class="assessment-content">
      <div class="header-row">
        <h1>Assessment Questions</h1>
        <button @click="showCreateForm = true" class="btn btn-primary">
          <i class="bi bi-plus-circle me-2"></i>Create New
        </button>
      </div>
      
      <div v-if="showCreateForm" class="card mb-4">
        <div class="card-body">
          <div class="mb-3">
            <input v-model="newQuestion.question" class="form-control mb-3" placeholder="Question">
            <select v-model="newQuestion.part_id" class="form-select mb-3">
              <option value="">Select Part</option>
              <option v-for="part in parts" :value="part.id" :key="part.id">{{ part.title }}</option>
            </select>
            <button @click="addOptionField" class="btn btn-sm btn-outline-secondary">Add Option</button>
          </div>
          <div v-for="(option, index) in newQuestion.options" :key="'new-option-' + index" class="mb-3">
            <input v-model="option.value" class="form-control mb-2" placeholder="Option value">
            <input v-model="option.value_ar" class="form-control" placeholder="Arabic value">
            <button @click="removeOptionField(index)" class="btn btn-sm btn-danger mt-2">Remove</button>
          </div>
          <div class="d-flex gap-2">
            <button @click="createQuestion" class="btn btn-success">Create</button>
            <button @click="cancelCreate" class="btn btn-secondary">Cancel</button>
          </div>
        </div>
      </div>

      <div class="assessment-questions">
        <div v-for="question in assessmentQuestions" :key="question.id" class="option-item">
          <template v-if="editingQuestionId === question.id">
            <div class="card mb-3">
              <div class="card-body">
                <input v-model="editingValues.question" class="form-control mb-3" placeholder="Question">
                <input v-model="editingValues.question_ar" class="form-control mb-3" placeholder="Arabic Question">
                <!-- <select v-model="editingValues.part_id" class="form-select mb-3">
                  <option v-for="part in parts" :value="part.id" :key="part.id">{{ part.title }}</option>
                </select>
                <div v-for="(option, index) in editingValues.options" :key="'edit-option-' + index" class="mb-3">
                  <input v-model="option.value" class="form-control mb-2">
                  <input v-model="option.value_ar" class="form-control">
                  <button @click="removeOptionEdit(index)" class="btn btn-sm btn-danger mt-2">Remove</button>
                </div>-->
                <!-- <button @click="addOptionEdit" class="btn btn-sm btn-outline-secondary mb-3">Add Option</button> -->
                <div class="d-flex gap-2">
                  <button @click="updateQuestion(question.id)" class="btn btn-primary">Save</button>
                  <button @click="cancelEdit" class="btn btn-secondary">Cancel</button>
                </div> 
              </div>
            </div>
          </template>
          <template v-else>
            <div class="d-flex justify-content-between align-items-start mb-3">
              <div>
                <h3 class="question">{{ question.question }}</h3>
                <h3 class="question">{{ question.question_ar }}</h3>
                <p class="part-title">Part: {{ question.part ? question.part.title : 'No part assigned' }}</p>
              </div>
              <div class="action-buttons">
                <button @click="startEdit(question)" class="btn btn-sm btn-outline-primary me-2">
                  <i class="bi bi-pencil-square"></i>
                </button>
                <button @click="deleteQuestion(question.id)" class="btn btn-sm btn-outline-danger">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from 'axios';
import Sidebar from '@/components/Sidebar.vue';

export default {
  name: 'AssessmentQuestions',
  components: {
    Sidebar
  },
  data() {
    return {
      assessmentQuestions: [],
      parts: [],
      showCreateForm: false,
      editingQuestionId: null,
      newQuestion: {
        question: '',
        part_id: '',
        options: [{ value: '', value_ar: '' }]
      },
      editingValues: {
        question: '',
        question_ar: '',
        part_id: '',
        options: []
      }
    };
  },
  async mounted() {
    try {
      const [questionsRes, partsRes] = await Promise.all([
        axios.get('https://api.kewaar.com/api/admin/assessment-questions', {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        }),
        axios.get('https://api.kewaar.com/api/admin/assessment-parts', {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        })
      ]);
      
      this.parts = partsRes.data;
      
      // Process questions to ensure each has a part object if there's a part_id
      const questions = questionsRes.data;
      questions.forEach(question => {
        if (question.part_id && !question.part) {
          const part = this.parts.find(p => p.id === question.part_id);
          if (part) {
            question.part = part;
          }
        }
        // Ensure options is always an array
        if (!Array.isArray(question.options)) {
          question.options = [];
        }
      });
      
      this.assessmentQuestions = questions;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  },
  methods: {
    async fetchData() {
      try {
        const [questionsRes, partsRes] = await Promise.all([
          axios.get('https://api.kewaar.com/api/admin/assessment-questions', {
            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }),
          axios.get('https://api.kewaar.com/api/admin/assessment-parts', {
            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          })
        ]);
        
        this.parts = partsRes.data;
        
        // Process questions to ensure each has a part object if there's a part_id
        const questions = questionsRes.data;
        questions.forEach(question => {
          if (question.part_id && !question.part) {
            const part = this.parts.find(p => p.id === question.part_id);
            if (part) {
              question.part = part;
            }
          }
        });
        
        this.assessmentQuestions = questions;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
    startEdit(question) {
      this.editingQuestionId = question.id;
      this.editingValues = {
        question: question.question || '',
        question_ar: question.question_ar || '',
        part_id: question.part_id || '',
        options: Array.isArray(question.options) ? [...question.options] : []
      };
    },
    cancelEdit() {
      this.editingQuestionId = null;
      this.editingValues = { question: '', question_ar: '', part_id: '', options: [] };
    },
    addOptionField() {
      this.newQuestion.options.push({ value: '', value_ar: '' });
    },
    removeOptionField(index) {
      this.newQuestion.options.splice(index, 1);
    },
    addOptionEdit() {
      this.editingValues.options.push({ value: '', value_ar: '' });
    },
    removeOptionEdit(index) {
      this.editingValues.options.splice(index, 1);
    },
    async createQuestion() {
      try {
        const response = await axios.post('https://api.kewaar.com/api/admin/assessment-questions', 
          this.newQuestion,
          { headers: { Authorization: 'Bearer ' + localStorage.getItem('token') } }
        );
        
        // Ensure response data has part object
        const newQuestionData = response.data;
        if (newQuestionData.part_id && !newQuestionData.part) {
          // If response doesn't include part object, find it from parts array
          const part = this.parts.find(p => p.id === newQuestionData.part_id);
          if (part) {
            newQuestionData.part = part;
          }
        }
        
        this.assessmentQuestions.push(newQuestionData);
        this.cancelCreate();
      } catch (error) {
        console.error('Error creating question:', error);
      }
    },
    cancelCreate() {
      this.showCreateForm = false;
      this.newQuestion = { question: '', part_id: '', options: [{ value: '', value_ar: '' }] };
    },
    async updateQuestion(id) {
      try {
        const response = await axios.put(`https://api.kewaar.com/api/admin/assessment-questions/${id}`,
          this.editingValues,
          { headers: { Authorization: 'Bearer ' + localStorage.getItem('token') } }
        );
        const index = this.assessmentQuestions.findIndex(q => q.id === id);
        
        // Ensure response data has part object
        const updatedQuestion = response.data;
        if (updatedQuestion.part_id && !updatedQuestion.part) {
          // If response doesn't include part object, find it from parts array
          const part = this.parts.find(p => p.id === updatedQuestion.part_id);
          if (part) {
            updatedQuestion.part = part;
          }
        }
        
        this.assessmentQuestions.splice(index, 1, updatedQuestion);
        this.cancelEdit();
      } catch (error) {
        console.error('Error updating question:', error);
      }
    },
    async deleteQuestion(id) {
      if (!confirm('Are you sure you want to delete this question?')) return;
      try {
        await axios.delete(`https://api.kewaar.com/api/admin/assessment-questions/${id}`, {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        });
        this.assessmentQuestions = this.assessmentQuestions.filter(q => q.id !== id);
      } catch (error) {
        console.error('Error deleting question:', error);
      }
    },
    async deleteOption(id) {
      if (!confirm('Are you sure you want to delete this option?')) return;
      try {
        await axios.delete(`https://api.kewaar.com/api/admin/assessment-options/${id}`, {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        });
        this.assessmentQuestions = this.assessmentQuestions.map(question => ({
          ...question,
          options: question.options.filter(opt => opt.id !== id)
        }));
      } catch (error) {
        console.error('Error deleting option:', error);
      }
    }
  }
};
</script>

<style scoped>
/* Add layout styles */
.assessment-layout {
  display: flex;
  min-height: 100vh;
}

.assessment-content {
  flex: 1;
  margin-left: 280px; /* Match sidebar width */
  padding: 2rem;
  background-color: #f8fafc;
  min-height: 100vh;
}

/* Header styles */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.header-row h1 {
  color: #1e293b;
  font-size: 2rem;
  font-weight: 600;
}

.assessment-questions {
  display: grid;
  gap: 1rem;
}

.option-item {
  padding: 1.5rem;
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.question {
  color: #1e293b;
  margin-bottom: 1rem;
  font-size: 1.25rem;
  font-weight: 500;
}

.part-title {
  color: #64748b;
  margin-bottom: 1rem;
  font-size: 0.9em;
}

.options-container {
  display: grid;
  gap: 0.5rem;
}

.value-item {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  background-color: #f8fafc;
  border-radius: 0.375rem;
  border: 1px solid #e2e8f0;
}

.action-buttons {
  display: flex;
  align-items: center;
}

.option-text {
  flex: 1;
  padding: 0.25rem 0;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.375rem 0.75rem;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .assessment-content {
    margin-left: 0;
    padding: 1rem;
  }
  
  .assessment-layout {
    flex-direction: column;
  }
}
</style> 